<template>
  <Tooltip :label="tooltipLabel" @click="onClicked" :linkStyle="editing" placement="top">
    <span v-if="iconStackClass" class="fa-stack order-item-container" style="font-size: 0.6em;">
      <i :class="['fas', 'fa-circle', 'fa-xs', 'fa-stack-1x', iconStackClass]" style="font-size: 0.5rem;"></i>
      <i :class="[iconStyle, icon, 'fa-stack-1x', 'order-item-icon', value ? iconClass : '']"></i>
    </span>
    <i v-if="!iconStackClass" :class="[iconStyle, icon, 'order-item-container', 'order-item-icon', value ? iconClass : '']"></i>
  </Tooltip>
</template>

<style scoped>
.order-item-icon {
  font-size: 13px;
  color: #d7d7d7;
}
.theme-dark .order-item-icon {
  color: #606060;
}
.fa-stack.order-item-container {
  margin-right: 6px;
}
.order-item-container {
  margin-right: 9px;
}
</style>

<script>
export default {
  name: 'OrderItemIcon',
  props: {
    name: String,
    editing: Boolean,
    label: String,
    icon: String,
    iconStyle: {
      type: String,
      default: 'far'
    },
    iconClass: String,
    iconStackClass: String,
    value: Boolean
  },
  computed: {
    tooltipLabel() {
      let label = (this.label || this.name || '').trim()
      if(label.split('\n').length > 1)
        return 'Multiple errors'
      return label
    }
  },
  methods: {
    onClicked(evt) {
      if(this.editing)
        this.$emit('click', evt)
    }
  }
}
</script>